var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Dropdown from '../dropdown';
import { Styled } from './style';
var AppCategorySidebar = /** @class */ (function (_super) {
    __extends(AppCategorySidebar, _super);
    function AppCategorySidebar(props) {
        return _super.call(this, props) || this;
    }
    AppCategorySidebar.prototype.onItemClick = function (type, value) {
        if (this.props.onItemClick) {
            this.props.onItemClick(type, value);
        }
    };
    AppCategorySidebar.prototype.categories = function (mobile) {
        var _this = this;
        var _a, _b;
        var allAppCount = (_a = this.props.categories) === null || _a === void 0 ? void 0 : _a.reduce(function (count, current) { return count + current.count; }, 0);
        var result = (_b = this.props.categories) === null || _b === void 0 ? void 0 : _b.map(function (category) {
            if (mobile) {
                return { key: category.id, text: category.name, value: category.id };
            }
            return (React.createElement("li", { key: category.id, className: "item" },
                React.createElement("a", { onClick: _this.onItemClick.bind(_this, 'category', category.id), className: "link " + (_this.props.selectedCategory && _this.props.selectedCategory.includes(category.id) ? 'selected' : '') },
                    React.createElement("span", null, category.name),
                    React.createElement("span", { className: "app-count" }, category.count))));
        });
        if (result && !mobile) {
            result.unshift(React.createElement("li", { key: "newapps", className: "item" },
                React.createElement("a", { onClick: this.onItemClick.bind(this, 'category', 'all'), className: "link " + (!this.props.selectedCategory || !this.props.selectedCategory.length ? 'selected' : '') },
                    React.createElement("span", null, "All Apps"),
                    React.createElement("span", { className: "app-count" }, allAppCount)),
                this.props.newcount && React.createElement("i", { className: "new" }, this.props.newcount)));
        }
        return result;
    };
    AppCategorySidebar.prototype.third = function (mobile) {
        var _this = this;
        return (this.props.third &&
            this.props.third.map(function (third) {
                if (mobile) {
                    return { key: third.id, text: third.name, value: third.id };
                }
                return (React.createElement("li", { key: third.id, className: "item" },
                    React.createElement("a", { onClick: _this.onItemClick.bind(_this, 'third', third.id), className: "link " + (_this.props.selectedThird && _this.props.selectedThird.includes(third.id) ? 'selected' : '') },
                        React.createElement("span", null, third.name))));
            }));
    };
    AppCategorySidebar.prototype.features = function (mobile) {
        var _this = this;
        return (this.props.features &&
            this.props.features.map(function (feature) {
                if (mobile) {
                    return { key: feature.id, text: feature.name, value: feature.id };
                }
                return (React.createElement("li", { key: feature.id, className: "item" },
                    React.createElement("a", { onClick: _this.onItemClick.bind(_this, 'feature', feature.id), className: "link " + (_this.props.selectedFeature && _this.props.selectedFeature.includes(feature.id) ? 'selected' : '') },
                        React.createElement("span", null, feature.name))));
            }));
    };
    AppCategorySidebar.prototype.wrapper = function (title, type, data) {
        var _this = this;
        var list = data.bind(this)();
        if (!list || !list.length) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("h3", { className: "title" }, title),
            React.createElement("ul", { className: "list" }, list),
            React.createElement(Dropdown, { inline: true, className: "dropper", text: title, options: data.bind(this)(true), onChange: function (e, _a) {
                    var value = _a.value;
                    _this.onItemClick(type, value);
                } })));
    };
    AppCategorySidebar.prototype.render = function () {
        return (React.createElement(Styled, { className: this.props.className },
            this.wrapper('Browse', 'category', this.categories),
            this.wrapper('3rd Party Subscriptions', 'third', this.third),
            this.wrapper('Features', 'feature', this.features)));
    };
    return AppCategorySidebar;
}(React.Component));
export default AppCategorySidebar;
//# sourceMappingURL=index.js.map